var map = {
	"./arr1.svg": "d500",
	"./arr2.svg": "cc7e",
	"./background-main-act.svg": "308f",
	"./background-main-callcenter.svg": "0c37",
	"./background-main-credit.svg": "f15b",
	"./background-main-decree.svg": "68d7",
	"./background-main-kvota-eng.svg": "258e",
	"./background-main-kvota.svg": "4daf",
	"./background-main-map.svg": "cab6",
	"./background-main-mobile-act.svg": "b7a6",
	"./background-main-mobile-credit.svg": "6f6f",
	"./background-main-mobile-decree.svg": "d62d",
	"./background-main-mobile-kvota-eng.svg": "a7cc",
	"./background-main-mobile-kvota.svg": "c052",
	"./background-main-mobile.svg": "5160",
	"./background-main-new.svg": "88f4",
	"./background-main.svg": "601e",
	"./background-mainPage.svg": "0440",
	"./breadcrumb-divider.svg": "8c11",
	"./cross.svg": "4915",
	"./empty-star.svg": "5822",
	"./eng-otz-man.svg": "4f53",
	"./eng-otz-woman.svg": "99d1",
	"./engman-otz.svg": "46d8",
	"./engman-otzS.svg": "d7e1",
	"./engwoman-otz.svg": "fe74",
	"./engwoman-otzS.svg": "c661",
	"./filled-star.svg": "7b87",
	"./icon-act.svg": "cd88",
	"./icon-arrow-background-btn-down.svg": "8aa5",
	"./icon-arrow-background-btn-left.svg": "13c3",
	"./icon-arrow-background-btn-right.svg": "cd2e",
	"./icon-arrow-background-btn-up.svg": "1fb6",
	"./icon-arrow-background-btn.svg": "c036",
	"./icon-arrow-flat.svg": "02f6",
	"./icon-arrow-menu.svg": "ef30",
	"./icon-arrow-up.svg": "cdec",
	"./icon-arrow.svg": "9f84",
	"./icon-close.svg": "3c76",
	"./icon-conference.svg": "a803",
	"./icon-email.svg": "2ed8",
	"./icon-excel.svg": "de88",
	"./icon-info.svg": "1531",
	"./icon-instagram.svg": "3b08",
	"./icon-logout.svg": "51a8",
	"./icon-odnoklassniki.svg": "e82b",
	"./icon-pencil.svg": "e235",
	"./icon-plus.svg": "77ea",
	"./icon-powerpoint.svg": "7eda",
	"./icon-search.svg": "e854",
	"./icon-seminar.svg": "4753",
	"./icon-tel.svg": "3e09",
	"./icon-telegram.svg": "7a61",
	"./icon-tick.svg": "c70d",
	"./icon-trash.svg": "2d7f",
	"./icon-vk.svg": "3699",
	"./icon-webinar.svg": "8e27",
	"./icon-whatsapp.svg": "3d23",
	"./icon-word.svg": "34ee",
	"./logo-archive.svg": "bceb",
	"./logo-aspirantura.svg": "dcfb",
	"./logo-assistentura.svg": "d00e",
	"./logo-bakalavriat.svg": "9a6e",
	"./logo-belarus.svg": "f33e",
	"./logo-budget.svg": "2259",
	"./logo-celevoe.svg": "c465",
	"./logo-education-in-russia.svg": "6865",
	"./logo-events.svg": "0e7c",
	"./logo-faq.svg": "7353",
	"./logo-footer.svg": "86c5",
	"./logo-foreign-applicant.svg": "0bbb",
	"./logo-gosuslugi.svg": "05d8",
	"./logo-header.svg": "7d26",
	"./logo-interobrazovanie-white.svg": "ce9f",
	"./logo-kvota.svg": "bbee",
	"./logo-login.svg": "d97d",
	"./logo-magistratura.svg": "69d4",
	"./logo-mezhdunarodnye.svg": "0394",
	"./logo-minobr-footer-eng.svg": "1280",
	"./logo-minobr-footer.svg": "c2a6",
	"./logo-minobr.svg": "9aca",
	"./logo-obshiy.svg": "de75",
	"./logo-ordinatura.svg": "e51c",
	"./logo-pisma.svg": "946e",
	"./logo-portal-ege.svg": "ce05",
	"./logo-postupai-pravilno.svg": "f37c",
	"./logo-priemvuz-blue-eng.svg": "bfbc",
	"./logo-priemvuz-blue.svg": "d0eb",
	"./logo-priemvuz-white-footer-eng.svg": "b247",
	"./logo-priemvuz-white-footer.svg": "0ea8",
	"./logo-priznanie.svg": "f031",
	"./logo-recognition.svg": "3ba8",
	"./logo-rosobrnadzor.svg": "bc4f",
	"./logo-russian-applicant.svg": "0da8",
	"./logo-zakony.svg": "2614",
	"./m-02.svg": "7ade",
	"./m-03.svg": "3fb4",
	"./man-otz.svg": "6b50",
	"./man-otzS.svg": "1860",
	"./marks.svg": "43e4",
	"./star.svg": "dbfd",
	"./telegram.svg": "0c86",
	"./w-02.svg": "8009",
	"./w-03.svg": "fe84",
	"./warning-rotate-arrows.svg": "4a2c",
	"./warning-rotate-phone.svg": "66c1",
	"./woman-otz.svg": "50a6",
	"./woman-otzS.svg": "5d94",
	"./схема_подача_документов.svg": "33a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";